<script lang="ts">
  import i18n from '../../i18n'
  import ContextMenuContent from '../context-menu/ContextMenuContent.svelte'
  import ContextMenuPrinter from '../context-menu/ContextMenuPrinter.svelte'
  import ContextMenuSubmenu from '../context-menu/ContextMenuSubmenu.svelte'
  import { ThreeItemKeys } from '../../constants/three'
  import ContextMenuSeparator from '../context-menu/ContextMenuSeparator.svelte'
  import ContextMenuItem from '../context-menu/ContextMenuItem.svelte'
  import usePrintersQueries from '../../routes/project/hooks/usePrintersQueries'
  import { getPrinterId } from '../../helpers/printer'
  import useFileQueries from '../../routes/project/hooks/useFileQueries'

  type Props = {
    fileId: string
    assignedPrinterId?: string
    onRename?: () => void
  }

  let { fileId, assignedPrinterId, onRename }: Props = $props()
  const { assignToPrinterMutation, focusCamera, removeMutation, splitByContoursMutation }
    = useFileQueries()

  const { usePrinters } = usePrintersQueries()
  const printersData = usePrinters()
</script>

<ContextMenuContent>
  <ContextMenuSubmenu label={$i18n.t('project.leftBar.files.contextMenu.assignTo')}>
    <ContextMenuPrinter
      name={$i18n.t('project.leftBar.files.contextMenu.noPrinter')}
      onClick={() => assignToPrinterMutation.mutate({ fileId, printerId: undefined })}
      selected={!assignedPrinterId}
    />
    {#each printersData.data || [] as printer (printer.uuid)}
      <ContextMenuSeparator />
      <ContextMenuPrinter
        name={printer.name}
        color={printer.userData[ThreeItemKeys.PRINTER_COLOR]}
        onClick={() => assignToPrinterMutation.mutate({ fileId, printerId: getPrinterId(printer) })}
        selected={assignedPrinterId === getPrinterId(printer)}
      />
    {/each}
  </ContextMenuSubmenu>
  <ContextMenuItem onClick={() => focusCamera(fileId)}>
    {$i18n.t('project.leftBar.files.contextMenu.focus')}
  </ContextMenuItem>

  {#if onRename}
    <ContextMenuSeparator />
    <ContextMenuItem onClick={onRename}>
      {$i18n.t('project.leftBar.files.contextMenu.rename')}
    </ContextMenuItem>
  {/if}

  <ContextMenuSeparator />
  <ContextMenuItem onClick={() => splitByContoursMutation.mutate(fileId)}>
    {$i18n.t('project.leftBar.files.contextMenu.split')}
  </ContextMenuItem>

  <ContextMenuSeparator />
  <ContextMenuItem
    onClick={() => removeMutation.mutate(fileId)}
    variant="destructive"
  >
    {$i18n.t('project.leftBar.files.contextMenu.delete')}
  </ContextMenuItem>
</ContextMenuContent>
